import React, { useState, useEffect } from "react";

import { useNavigate, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { GET_PO_LIST, MODIFY_PO, APPROVE_MODIFIED_PO, EDIT_PO, DELETE_PO } from '../../../common/URLs';
import jwt from 'jwt-decode';
import { Container, Button, Box, Stack, Typography, Tab, Checkbox, Card, IconButton, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material'
import { DataGrid, GridEditInputCell, useGridApiContext } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { PROD } from "../../../common/constants";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { loaderService } from "../../../common/custom-loader/loader-service";
import { toast } from 'react-toastify';
import { useTranslation } from "react-i18next";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { PIT_VALIDATIONS } from "../../../common/commonValidations";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { CancelIcon, DeleteIcon, EditIcon, UpdateIcon, ViewIcon } from "../../../common/icons";
import apiClient from "../../../axios";
import moment from "moment";
import CustomDataGridToolbarServer from "../../../common/customDataGridToolbarServer";
import { Badge } from "react-bootstrap";

function ScoList() {
  const decoded = jwt(getLocalStorageItem('id_token'));
  const navigate = useNavigate();
  const { state } = useLocation();
  const { t } = useTranslation();
  const [poList, setPoList] = useState();
  const [tabValue, setTabValue] = useState(state?.tabVal ? state?.tabVal : decoded.extension_URN ? "1" : "0");
  const [selectedIds, setSelectedIds] = useState([])
  const selectedRows = poList?.filter((row) => selectedIds?.includes(row?.id));
  const [formattedData, setFormattedData] = useState([]);
  const [isApiCalled, setIsApiCalled] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const handleConfirmOpen = () => setConfirmOpen(true);
  const handleConfirmClose = () => setConfirmOpen(false);

  const [confirmOpen2, setConfirmOpen2] = useState(false);
  const handleConfirmOpen2 = () => setConfirmOpen2(true);
  const handleConfirmClose2 = () => setConfirmOpen2(false);

  const [searchText, setSearchText] = useState("");
  const [sortField, setSortField] = useState("CreatedOn");
  const [sortOrder, setSortOrder] = useState("desc");

  const [confirmOpen3, setConfirmOpen3] = useState(false);
  const handleConfirmOpen3 = () => setConfirmOpen3(true);
  const handleConfirmClose3 = () => setConfirmOpen3(false);

  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editConfirmOpen, setEditConfirmOpen] = useState(false);
  const [selectedEditRow, setSelectedEditRow] = useState(null);
  const [editForm, setEditForm] = useState({
    modifiedPOQuantity: "",
    poDescription: ""
  });
  const [editFormError, setEditFormError] = useState({
    modifiedPOQuantity: "",
    poDescription: ""
  });

  const handleEditDialogOpen = (row) => {
    setSelectedEditRow(row);
    setEditForm({
      modifiedPOQuantity: row?.poQuantity ?? "",
      poDescription: row?.poDescription?.replace(/<br\s*\/?>/gi, '\n') ?? ""
    });
    setEditFormError({
      modifiedPOQuantity: "",
      poDescription: ""
    });
    setEditDialogOpen(true);
  };

  const handleEditDialogClose = () => {
    setEditDialogOpen(false);
    setSelectedEditRow(null);
    setEditForm({
      modifiedPOQuantity: "",
      poDescription: ""
    });
    setEditFormError({
      modifiedPOQuantity: "",
      poDescription: ""
    });
  };

  const handleEditConfirmClose = () => {
    setEditConfirmOpen(false);
  };


  const onViewDetails = (cellValues) => {
    navigate('/dashboardHome/scoList/sco', {
      state: { selectedRow: cellValues.row, screen: "list", tabVal: tabValue }
    });
  }


  const handleCheckboxChange = (event, row) => {
    const selectedId = row.id;
    const isSelected = event.target.checked;
    const newSelectedIds = isSelected
      ? [...selectedIds, selectedId]
      : selectedIds.filter((id) => id !== selectedId);
    setSelectedIds(newSelectedIds);

  };

  const validateEditForm = () => {
    let errors = {
      modifiedPOQuantity: "",
      poDescription: ""
    };

    const qtyError = PIT_VALIDATIONS.qtyValidation(
      editForm.modifiedPOQuantity,
      selectedEditRow?.grnQuantity,
      8,
      4
    );

    const descError = PIT_VALIDATIONS.commentValidation(editForm.poDescription);

    if (
      editForm.modifiedPOQuantity === null ||
      editForm.modifiedPOQuantity === undefined ||
      editForm.modifiedPOQuantity === ""
    ) {
      errors.modifiedPOQuantity = "Modified SCO Quantity is required";
    } else if (qtyError) {
      errors.modifiedPOQuantity = qtyError;
    }

    if (!editForm.poDescription) {
      errors.poDescription = "SCO Description is required";
    } else if (descError) {
      errors.poDescription = descError;
    }

    setEditFormError(errors);

    return !errors.modifiedPOQuantity && !errors.poDescription;
  };

  const onEditSubmitClick = () => {
    if (!validateEditForm()) return;
    setEditDialogOpen(false);
    setEditConfirmOpen(true);
  };

  const onConfirmEditPO = async () => {
    if (isApiCalled) return;
    setIsApiCalled(true);
    try {
      await editPO();
      await new Promise((resolve) => setTimeout(resolve, 1000));
    } catch (error) {
      console.error("API failed:", error);
    } finally {
      setEditConfirmOpen(false);
      setIsApiCalled(false);
      handleEditDialogClose();
    }
  };


  const editPO = async () => {
    const payloadWithNewline = editForm?.poDescription?.replace(/\n/g, "<br />");
    loaderService.showLoader();
    return await apiClient
      .post(
        EDIT_PO,
        {
          "poNumber": selectedEditRow?.poNumber,
          "modifiedPOQuantity": Number(editForm.modifiedPOQuantity),
          "poDescription": payloadWithNewline
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem('id_token')
          }
        },
        null
      )
      .then((response) => {
        if (response?.data?.isSuccess === true) {
          toast.success(response?.data?.message || "SCO updated successfully");
        } else {
          toast.error(response?.data?.message || "Unable to update SCO");
        }
        getPoList(tabValue, page, pageSize, sortField, sortOrder, searchText);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error?.message || "Error while updating SCO");
      })
  };

  const pendingCol = [
    {
      field: 'checkbox',
      headerName: 'Select All',
      width: 80,
      sortable: false,
      hide: decoded.extension_URN,
      renderHeader: () => (
        <Checkbox
          checked={selectedIds.length === poList.length && poList.length > 0}
          onChange={(event) => event.target.checked ? setSelectedIds(poList.map((item) => item.id)) : setSelectedIds([])}
        />
      ),
      renderCell: (params) => (
        <Checkbox
          checked={selectedIds.includes(params.row.id)}
          onChange={(event) => handleCheckboxChange(event, params.row)}
          disabled={params.row.poStatus !== "Created"}
        />
      ),
    },
    { field: 'poNumber', headerName: t('pit.scoNo'), width: 110 },
    { field: 'planningNumber', headerName: t('pit.planningNo'), width: 130 },
    { field: 'poStakeholderUrn', headerName: t('pit.stakeholderUrn'), width: 130 },
    { field: 'poStakeholderName', headerName: t('pit.stakeholderName'), width: 150 },
    { field: 'poStakeholderEmailId', headerName: t('main.email'), width: 180 },
    { field: 'poQuantity', headerName: t('pit.scoQuantity'), width: 100 },
    { field: 'grnQuantity', headerName: t('pit.received qty'), width: 140 },
    { field: 'poBalanceQuantityAfterGrn', headerName: t('pit.scoBalanceQuantity'), width: 130 },
    { field: 'scheduledQuantity', headerName: t('pit.scheduled quantity'), width: 150 },
    {
      field: 'modifiedPoQuantity', headerName: t('pit.Modified SCO Quantity'), width: 150,
      // editable: decoded.extension_URN ? false : true,
      type: 'number',
      // align: "center",
      // preProcessEditCellProps: (params) => {
      //   return { ...params.props, error: PIT_VALIDATIONS.qtyValidation(params.props.value, params.row.grnQuantity, 8, 4) };
      // },
      // renderEditCell: renderEdit,
    },
    {
      field: 'modifiedPoComment', headerName: "Comment", width: 250,
      // editable: decoded.extension_URN ? false : true,
      type: 'text',
      // align: "center",
      // cellClassName: 'confirmationStatusPending',
      // preProcessEditCellProps: (params) => {
      //   return { ...params.props, error: PIT_VALIDATIONS.commentValidation(params.props.value, 200) };
      // },
      // renderEditCell: renderCommentEdit,

    },
    { field: 'poUnitPrice', headerName: t('pit.Unit Price'), width: 150 },
    { field: 'totalAmount', headerName: t('pit.Total Amount'), width: 150 },
    // { field: 'destinationStakeholderType', headerName: t('pit.destination stakeholder type'), width: 130 },
    // { field: 'destinationStakeholderUrn', headerName: t('pit.destination stakeholder URN'), width: 130 },
    {
      field: 'poStatus', headerName: t('pit.status'), width: 150, hide: decoded.extension_URN,
      // renderCell: (params) => {
      //     return params.row.isApproved === 1 ? "Approved" : "Pending"
      // }
    },
    { field: 'currentOwner', headerName: t('pit.current Owner'), width: 150, hide: decoded.extension_URN, },
    {
      field: t('reg.actions'), width: 100,
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title={t('pit.view')}>
              <IconButton color="primary">
                <ViewIcon onClick={() => onViewDetails(cellValues)}
                />
              </IconButton>
            </Tooltip>
            {!decoded.extension_URN && (
              <Tooltip title={t('pit.edit')}>
                <IconButton
                  color="primary"
                  onClick={() => handleEditDialogOpen(cellValues.row)}
                  disabled={cellValues?.row?.poStatus !== "Created"}
                >
                  <EditIcon />
                </IconButton>
              </Tooltip>
            )}
          </>
        );
      }
    },
  ];

  const approvedCol = [

    { field: 'poNumber', headerName: t('pit.scoNo'), width: 110 },
    { field: 'planningNumber', headerName: t('pit.planningNo'), width: 130 },
    {
      field: 'approvedOn', headerName: t('pit.scoDate'), width: 130,
      valueFormatter: params => params.value !== null ? moment(params?.value).format("DD/MM/YYYY") : "",
    },
    { field: 'poStakeholderUrn', headerName: t('pit.stakeholderUrn'), width: 130 },
    { field: 'poStakeholderName', headerName: t('pit.stakeholderName'), width: 150 },
    { field: 'poStakeholderEmailId', headerName: t('main.email'), width: 180 },
    { field: 'poQuantity', headerName: t('pit.scoQuantity'), width: 100 },
    { field: 'grnQuantity', headerName: t('pit.received qty'), width: 140 },
    { field: 'poBalanceQuantityAfterGrn', headerName: t('pit.scoBalanceQuantity'), width: 130 },
    { field: 'scheduledQuantity', headerName: t('pit.scheduled quantity'), width: 150 },
    {
      field: 'modifiedPoQuantity', headerName: t('pit.Modified SCO Quantity'), width: 150,
      // editable: decoded.extension_URN ? false : true,
      // type: 'number',
      // align: "center",
      // preProcessEditCellProps: (params) => {
      //   return { ...params.props, error: PIT_VALIDATIONS.qtyValidation(params.props.value, params.row.scheduledQuantity, 8, 4) };
      // },
      // renderEditCell: renderEdit,
    },
    {
      field: 'modifiedPoComment', headerName: "Comment", width: 250,
      // editable: decoded.extension_URN ? false : true,
      // type: 'text',
      // align: "center",
      // cellClassName: 'confirmationStatusPending',
      // preProcessEditCellProps: (params) => {
      //   return { ...params.props, error: PIT_VALIDATIONS.commentValidation(params.props.value, 200) };
      // },
      // renderEditCell: renderCommentEdit,

    },
    { field: 'poUnitPrice', headerName: t('pit.Unit Price'), width: 150 },
    { field: 'totalAmount', headerName: t('pit.Total Amount'), width: 150 },
    // { field: 'destinationStakeholderType', headerName: t('pit.destination stakeholder type'), width: 130 },
    // { field: 'destinationStakeholderUrn', headerName: t('pit.destination stakeholder URN'), width: 130 },
    {
      field: 'poStatus', headerName: t('pit.status'), width: 150, hide: decoded.extension_URN,
      // renderCell: (params) => {
      //     return params.row.isApproved === 1 ? "Approved" : "Pending"
      // }
    },
    { field: 'currentOwner', headerName: t('pit.current Owner'), width: 150, hide: decoded.extension_URN, },
    {
      field: t('reg.actions'), width: 100,
      renderCell: (cellValues) => {
        return (
          <Tooltip title={t('pit.view')}>
            <IconButton color="primary">
              <ViewIcon onClick={() => onViewDetails(cellValues)}
              />
            </IconButton>
          </Tooltip>
        );
      }
    },
  ];

  const toBeModifiedCol = [
    {
      field: 'checkbox',
      headerName: 'Select All',
      width: 80,
      sortable: false,
      hide: decoded.extension_URN,
      renderHeader: () => (
        <Checkbox
          checked={selectedIds.length === poList.length && poList.length > 0}
          onChange={(event) => event.target.checked ? setSelectedIds(poList.map((item) => item.id)) : setSelectedIds([])}
        />
      ),
      renderCell: (params) => (
        <Checkbox
          checked={selectedIds.includes(params.row.id)}
          onChange={(event) => handleCheckboxChange(event, params.row)}
        // disabled={!(params.row.poBalanceQuantity > 0 && params.row.isSentBackForModification === true)}
        />
      ),
    },
    { field: 'poNumber', headerName: t('pit.scoNo'), width: 110 },
    { field: 'planningNumber', headerName: t('pit.planningNo'), width: 130 },
    { field: 'poStakeholderUrn', headerName: t('pit.stakeholderUrn'), width: 130 },
    { field: 'poStakeholderName', headerName: t('pit.stakeholderName'), width: 150 },
    { field: 'poStakeholderEmailId', headerName: t('main.email'), width: 180 },
    { field: 'poQuantity', headerName: t('pit.scoQuantity'), width: 100 },
    { field: 'grnQuantity', headerName: t('pit.received qty'), width: 140 },
    { field: 'poBalanceQuantityAfterGrn', headerName: t('pit.scoBalanceQuantity'), width: 130 },
    { field: 'scheduledQuantity', headerName: t('pit.scheduled quantity'), width: 150 },
    {
      field: 'modifiedPoQuantity', headerName: t('pit.Modified SCO Quantity'), width: 150, editable: decoded.extension_URN ? false : true,
      align: "center",
      valueFormatter: (params) => {
        const val = params?.value !== undefined ? params.value : params;
        return val != null ? String(val) : '';
      },

      sortComparator: (v1, v2) => Number(v1 || 0) - Number(v2 || 0),
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: PIT_VALIDATIONS.qtyValidation(params.props.value, params.row.grnQuantity, 8, 4) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'modifiedPoComment', headerName: "Comment", width: 250, editable: decoded.extension_URN ? false : true,
      type: 'text',
      align: "center",
      cellClassName: 'confirmationStatusPending',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: PIT_VALIDATIONS.commentValidation(params.props.value, 200) };
      },
      renderEditCell: renderCommentEdit,

    },
    { field: 'poUnitPrice', headerName: t('pit.Unit Price'), width: 150 },
    { field: 'totalAmount', headerName: t('pit.Total Amount'), width: 150 },
    // { field: 'destinationStakeholderType', headerName: t('pit.destination stakeholder type'), width: 130 },
    // { field: 'destinationStakeholderUrn', headerName: t('pit.destination stakeholder URN'), width: 130 },
    {
      field: 'poStatus', headerName: t('pit.status'), width: 150, hide: decoded.extension_URN,
      // renderCell: (params) => {
      //     return params.row.isApproved === 1 ? "Approved" : "Pending"
      // }
    },
    { field: 'currentOwner', headerName: t('pit.current Owner'), width: 150, hide: decoded.extension_URN, },
    {
      field: t('reg.actions'), width: 100,
      renderCell: (cellValues) => {
        return (
          <Tooltip title={t('pit.view')}>
            <IconButton color="primary">
              <ViewIcon onClick={() => onViewDetails(cellValues)}
              />
            </IconButton>
          </Tooltip>
        );
      }
    },
  ];

  const handleTabChange = (e, newValue) => {
    setTabValue(newValue);
    setSelectedIds([]);
    setPage(0);
    getPoList(newValue, 0, pageSize, sortField, sortOrder, searchText);
  }

  useEffect(() => {
    getPoList(tabValue, page, pageSize);
  }, [tabValue]);


  const getPoList = async (tabValue, page, pageSize, sortField, sortOrder, searchInput) => {
    loaderService.showLoader();
    return await apiClient
      .post(GET_PO_LIST,
        {
          "poType": "SCO",
          "approvalStatus": tabValue === "2" || tabValue === "3" ? "1" : tabValue,
          "stakeHolderUrn": decoded.extension_URN ? decoded.extension_URN : '',
          "isSentBackForModification": tabValue === "2" ? true : '',
          "IsPoQuantityModified": tabValue === '3' ? true : '',
          "pageNumber": page,
          "pageSize": pageSize,
          "filterText": searchInput
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        const list = response?.data?.poDetailsList || [];
        setPoList(list);
        setRowCount(response.data.rowCount)
        loaderService.hideLoader();
        return list;
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow }
    poList.forEach((item) => {
      if (item.id === updatedRow.id) {
        item.modifiedPoQuantity = updatedRow.modifiedPoQuantity
        item.modifiedPoComment = updatedRow.modifiedPoComment
      }
    })
    return updatedRow
  };

  const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText,
    },
  }));

  function EditInputCell(props) {
    const { error, id, value: valueProp, field } = props;
    const [value, setValue] = useState(valueProp);
    const apiRef = useGridApiContext();

    const handleChange = (event) => {
      const newValue = event.target.value;
      apiRef.current.setEditCellValue({ id, field, value: newValue });
      setValue(newValue);
    };

    useEffect(() => {
      setValue(valueProp);
    }, [valueProp]);

    return (
      <StyledTooltip open={!!error} title={error}>
        <GridEditInputCell {...props} value={value} onChange={handleChange} />
      </StyledTooltip>
    );
  }

  function renderEdit(params) {
    return <EditInputCell {...params} />;
  }

  function EditCommentInputCell(props) {
    const { id, field, value, error } = props;
    const apiRef = useGridApiContext();

    const handleChange = (event) => {
      const newValue = event.target.value;
      apiRef.current.setEditCellValue({ id, field, value: newValue }, event);
    };

    return (
      <StyledTooltip open={!!error} title={error || ''}>
        <GridEditInputCell {...props} value={value} onChange={handleChange} />
      </StyledTooltip>
    );
  }

  function renderCommentEdit(params) {
    return <EditCommentInputCell {...params} />;
  }

  // const onConfirmUpdate = (e) => {
  //   handleConfirmClose();
  //   modifyPo();
  // }

  const onConfirmUpdate = async () => {
    if (isApiCalled) return;
    setIsApiCalled(true);
    try {
      await modifyPo();
      await new Promise((resolve) => setTimeout(resolve, 1000));
    } catch (error) {
      console.error("API failed:", error);
    } finally {
      setConfirmOpen(false);
      setIsApiCalled(false);
    }
  };

  const onSubmitButtonClick = (e) => {
    handleConfirmOpen();
  }

  const fetchSearchData = async (searchInput) => {
    setSearchText(searchInput);
    await getPoList(tabValue, page, pageSize, sortField, sortOrder, searchInput);
  };
  const fetchData = async () => {
    return await getPoList(tabValue, 0, 0, sortField, sortOrder, searchText);
  }

  const onSubmit = (e) => {
    let tempArr = selectedRows?.map(item => {
      poList.filter((filterItem) => filterItem.id === item.id)
      return item
    });
    setFormattedData(tempArr?.map((row) => ({
      "poNumber": row?.poNumber,
      "isSentBackForModification": row?.isSentBackForModification === true ? true : row?.isSentBackForModification === false ? false : null,
      "modifiedPOQuantity": row?.modifiedPoQuantity,
      "modifiedPoComment": row.modifiedPoComment
    })));

    if (tempArr?.length === 0) {
      toast.error("Select atleast one SCO to update")
    }
    else if (tempArr?.some(item =>
      (item?.modifiedPoQuantity == null || item?.modifiedPoQuantity === '') &&
      (item?.modifiedPOQuantity == null || item?.modifiedPOQuantity === '')
    )) {
      toast.error("Modify SCO Quantity value is required to update the selected SCOs");
    }
    else if (!tempArr?.every((item) => item?.modifiedPoComment)) {
      toast.error("Comment is required to update the selected SCOs");
    }
    else {
      onSubmitButtonClick(e);
    }
  }

  const onSubmitClose = (e) => {
    let tempArr = selectedRows.map(item => {
      poList.filter((filterItem) => filterItem.id === item.id)
      return item
    });
    setFormattedData(tempArr?.map((row) => ({
      "poNumber": row?.poNumber,
      "isSentBackForModification": row?.isSentBackForModification,
      "modifiedPOQuantity": row?.grnQuantity ?? 0,
      "modifiedPoComment": "Close the SCO",
      "isPOCLosed": true
    })));
    if (tempArr?.length === 0) {
      toast.error("Select atleast one SCO to close")
    }
    else {
      onSubmitButtonClick2(e);
    }
  }

  const onSubmitButtonClick2 = (e) => {
    handleConfirmOpen2();
  }

  const onConfirmClosePO = async () => {
    if (isApiCalled) return;
    setIsApiCalled(true);
    try {
      await modifyPo();
      await new Promise((resolve) => setTimeout(resolve, 1000));
    } catch (error) {
      console.error("API failed:", error);
    } finally {
      setConfirmOpen2(false);
      setIsApiCalled(false);
    }
  };

  const modifyPo = async () => {
    loaderService.showLoader();
    return await apiClient
      .post(
        MODIFY_PO,
        {
          "modifyPoListDTO": formattedData,
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem('id_token')
          }
        },
        null
      )
      .then((response) => {
        if (response.data.isSuccess === true) {
          toast.success(response.data.message)
        }
        else toast.error(response.data.message)
        getPoList(tabValue, 0, pageSize, sortField, sortOrder, searchText);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      })
  };

  const onSubmitDelete = (e) => {
    let tempArr = selectedRows.map(item => {
      poList.filter((filterItem) => filterItem.id === item.id)
      return item
    });
    setFormattedData(tempArr?.map((row) => ({
      "poNumber": row?.poNumber,
    })));
    if (tempArr?.length === 0) {
      toast.error("Select atleast one SCO to delete")
    }
    else {
      handleConfirmOpen3(e);
    }
  }

  const onConfirmDeletePO = async () => {
    if (isApiCalled) return;
    setIsApiCalled(true);
    try {
      await deletePO();
      await new Promise((resolve) => setTimeout(resolve, 1000));
    } catch (error) {
      console.error("API failed:", error);
    } finally {
      setConfirmOpen3(false);
      setIsApiCalled(false);
    }
  };

  const deletePO = async () => {
    loaderService.showLoader();
    return await apiClient
      .post(
        DELETE_PO,
        {
          "deletePoListDTO": formattedData,
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem('id_token')
          }
        },
        null
      )
      .then((response) => {
        if (response.data.isSuccess === true) {
          toast.success(response.data.message)
        }
        else toast.error(response.data.message)
        getPoList(tabValue, 0, pageSize, sortField, sortOrder, searchText);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      })
  };


  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT55</p>}
        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between">
          <Typography variant="h4" gutterBottom>{t('pit.scoList')}</Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>
            <>
              <Stack direction="row" spacing={1} mb={1}>
                <Button startIcon={<UpdateIcon />} variant="contained" sx={{ minWidth: 100 }} disabled={poList?.length < 1} hidden={tabValue !== '2'} onClick={(e) => onSubmit(e)} >
                  Update
                </Button>
                <Button startIcon={<CancelIcon />} variant="contained" sx={{ minWidth: 100 }} disabled={poList?.length < 1} hidden={tabValue === '0' || tabValue === '1' || tabValue === '3'} onClick={(e) => onSubmitClose(e)} >
                  Close SCO
                </Button>
                <Button startIcon={<DeleteIcon />} color="error" variant="outlined" sx={{ minWidth: 100 }} disabled={poList?.length < 1} hidden={tabValue !== '0'} onClick={(e) => onSubmitDelete(e)} >
                  Delete SCO
                </Button>
              </Stack>
            </>
          </Stack>
        </Stack>
        <Card>
          <TabContext value={tabValue} style={{ marginLeft: "1.5vh" }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'whitesmoke' }}>
              <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                <Tab label={t('pit.SCO Pending List')} value="0" hidden={decoded.extension_URN} />
                <Tab label={t('pit.SCO Approved List')} value="1" />
                <Tab label='To be modified SCO' value="2" hidden={decoded.extension_URN} />
                <Tab label={t('Modified SCO')} value="3" hidden={decoded.extension_URN} />
              </TabList>
            </Box>
            <TabPanel value="0">
              <Box style={{ height: 500, width: '100%' }} sx={{
                '& .super-app-theme--header': {
                  wordWrap: 'break-word',
                  wordBreak: 'break-all',
                  whiteSpace: 'initial',
                },
                '& .MuiDataGrid-cell--editable': {
                  bgcolor: (theme) =>
                    theme.palette.mode === 'dark' ? '#376331' : 'rgb(217 243 190)',
                },
                '& .super-app.confirmationStatusPending': {
                  backgroundColor: '#FFFF8F',
                  color: '#1a3e72',
                  fontWeight: '600',
                },
                '& .super-app.confirmationStatusRejected': {
                  backgroundColor: '#F88379',
                  color: '#1a3e72',
                  fontWeight: '600',
                },
                '& .super-app.confirmationStatusConfirmed': {
                  backgroundColor: '#ECFFDC',
                  color: 'green',
                  fontWeight: '600',
                },
              }}>
                {
                  poList &&
                  <DataGrid
                    sx={{
                      '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '8px' },
                      '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
                      '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '22px' },
                    }}
                    getRowHeight={() => 'auto'}
                    getRowId={(row) => row.id}
                    rows={poList}
                    columns={pendingCol}
                    pagination
                    paginationMode="server"
                    page={page}
                    pageSize={pageSize}
                    rowCount={rowCount}
                    rowsPerPageOptions={[10, 20, 50, 100]}
                    onPageChange={(newPage) => {
                      setPage(newPage);
                      getPoList(tabValue, newPage, pageSize, sortField, sortOrder, searchText);
                    }}
                    onPageSizeChange={(newPageSize) => {
                      setPageSize(newPageSize);
                      setPage(0);
                      getPoList(tabValue, 0, newPageSize, sortField, sortOrder, searchText);
                    }}
                    components={{ Toolbar: CustomDataGridToolbarServer }}
                    componentsProps={{ toolbar: { columns: pendingCol, onSearch: fetchSearchData, onFetchData: fetchData, fileName: "SCO_Pending_List.xlsx", name: "Export to Excel", isExportToExcelRequired: true } }}
                  // isCellEditable={(params) => params.row.poBalanceQuantity > 0}
                  // experimentalFeatures={{ newEditingApi: true }}
                  // processRowUpdate={(e) => processRowUpdate(e)}
                  />
                }

              </Box>
            </TabPanel>
            <TabPanel value="1">
              <Box style={{ height: 500, width: '100%' }} >
                {
                  poList &&
                  <DataGrid
                    sx={{
                      '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '8px' },
                      '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
                      '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '22px' },
                    }}
                    getRowHeight={() => 'auto'}
                    getRowId={(row) => row.id}
                    rows={poList}
                    columns={approvedCol}
                    pagination
                    paginationMode="server"
                    page={page}
                    pageSize={pageSize}
                    rowCount={rowCount}
                    rowsPerPageOptions={[10, 20, 50, 100]}
                    onPageChange={(newPage) => {
                      setPage(newPage);
                      getPoList(tabValue, newPage, pageSize, sortField, sortOrder, searchText);
                    }}
                    onPageSizeChange={(newPageSize) => {
                      setPageSize(newPageSize);
                      setPage(0);
                      getPoList(tabValue, 0, newPageSize, sortField, sortOrder, searchText);
                    }}
                    components={{ Toolbar: CustomDataGridToolbarServer }}
                    componentsProps={{ toolbar: { columns: approvedCol, onSearch: fetchSearchData, onFetchData: fetchData, fileName: "SCO_Approved_List.xlsx", name: "Export to Excel", isExportToExcelRequired: true, dateFields: ['approvedOn'] } }}
                  />
                }

              </Box>
            </TabPanel>
            <TabPanel value="2">
              <Box style={{ height: 500, width: '100%' }} sx={{
                '& .super-app-theme--header': {
                  wordWrap: 'break-word',
                  wordBreak: 'break-all',
                  whiteSpace: 'initial',
                },
                '& .MuiDataGrid-cell--editable': {
                  bgcolor: (theme) =>
                    theme.palette.mode === 'dark' ? '#376331' : 'rgb(217 243 190)',
                },
                '& .super-app.confirmationStatusPending': {
                  backgroundColor: '#FFFF8F',
                  color: '#1a3e72',
                  fontWeight: '600',
                },
                '& .super-app.confirmationStatusRejected': {
                  backgroundColor: '#F88379',
                  color: '#1a3e72',
                  fontWeight: '600',
                },
                '& .super-app.confirmationStatusConfirmed': {
                  backgroundColor: '#ECFFDC',
                  color: 'green',
                  fontWeight: '600',
                },
              }}>
                {
                  poList &&
                  <DataGrid
                    sx={{
                      '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '8px' },
                      '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
                      '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '22px' },
                    }}
                    getRowHeight={() => 'auto'}
                    getRowId={(row) => row.id}
                    rows={poList}
                    columns={toBeModifiedCol}
                    pagination
                    paginationMode="server"
                    page={page}
                    pageSize={pageSize}
                    rowCount={rowCount}
                    rowsPerPageOptions={[10, 20, 50, 100]}
                    onPageChange={(newPage) => {
                      setPage(newPage);
                      getPoList(tabValue, newPage, pageSize, sortField, sortOrder, searchText);
                    }}
                    onPageSizeChange={(newPageSize) => {
                      setPageSize(newPageSize);
                      setPage(0);
                      getPoList(tabValue, 0, newPageSize, sortField, sortOrder, searchText);
                    }}
                    components={{ Toolbar: CustomDataGridToolbarServer }}
                    componentsProps={{ toolbar: { columns: toBeModifiedCol, onSearch: fetchSearchData, onFetchData: fetchData, fileName: "SCO_To_Be_Modified_List.xlsx", name: "Export to Excel", isExportToExcelRequired: true } }}
                    // isCellEditable={(params) => params.row.poBalanceQuantity > 0 && params.row.isSentBackForModification === true}
                    experimentalFeatures={{ newEditingApi: true }}
                    processRowUpdate={(e) => processRowUpdate(e)}
                  />
                }

              </Box>
            </TabPanel>
            <TabPanel value="3">
              <Box style={{ height: 500, width: '100%' }} >
                {
                  poList &&
                  <DataGrid
                    sx={{
                      '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '8px' },
                      '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
                      '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '22px' },
                    }}
                    getRowHeight={() => 'auto'}
                    getRowId={(row) => row.id}
                    rows={poList}
                    columns={approvedCol}
                    pagination
                    paginationMode="server"
                    page={page}
                    pageSize={pageSize}
                    rowCount={rowCount}
                    rowsPerPageOptions={[10, 20, 50, 100]}
                    onPageChange={(newPage) => {
                      setPage(newPage);
                      getPoList(tabValue, newPage, pageSize, sortField, sortOrder, searchText);
                    }}
                    onPageSizeChange={(newPageSize) => {
                      setPageSize(newPageSize);
                      setPage(0);
                      getPoList(tabValue, 0, newPageSize, sortField, sortOrder, searchText);
                    }}
                    components={{ Toolbar: CustomDataGridToolbarServer }}
                    componentsProps={{ toolbar: { columns: approvedCol, onSearch: fetchSearchData, onFetchData: fetchData, fileName: "SCO_Modified_List.xlsx", name: "Export to Excel", isExportToExcelRequired: true, dateFields: ['approvedOn'] } }}
                  />
                }

              </Box>
            </TabPanel>
          </TabContext>
        </Card>

      </Container >
      <Dialog open={editDialogOpen} onClose={handleEditDialogClose} maxWidth="sm" fullWidth>
        <DialogTitle>Edit SCO</DialogTitle>
        <DialogContent>
          <Stack spacing={2} mt={1}>
            <TextField
              label="Modified SCO Quantity"
              type="number"
              value={editForm.modifiedPOQuantity}
              onChange={(e) => {
                const value = e.target.value;
                setEditForm((prev) => ({
                  ...prev,
                  modifiedPOQuantity: value
                }));
                setEditFormError((prev) => ({
                  ...prev,
                  modifiedPOQuantity: PIT_VALIDATIONS.qtyValidation(value, selectedEditRow?.grnQuantity, 8, 4) || ""
                }));
              }}
              error={!!editFormError.modifiedPOQuantity}
              helperText={editFormError.modifiedPOQuantity}
              fullWidth
            />
            <TextField
              label="SCO Description"
              value={editForm.poDescription}
              onChange={(e) => {
                const value = e.target.value; // keep exact value with spaces/newlines
                setEditForm((prev) => ({
                  ...prev,
                  poDescription: value
                }));
                setEditFormError((prev) => ({
                  ...prev,
                  poDescription: PIT_VALIDATIONS.commentValidation(value) || ""
                }));
              }}
              error={!!editFormError.poDescription}
              helperText={editFormError.poDescription}
              fullWidth
              multiline
              minRows={4}
            />
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Badge>{editForm.poDescription?.length}</Badge>
            </div>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditDialogClose}>Cancel</Button>
          <Button variant="contained" onClick={onEditSubmitClick}>Submit</Button>
        </DialogActions>
      </Dialog>
      <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmUpdate} onClose={handleConfirmClose} action="Update" />
      <ConfirmationPopover onOpen={confirmOpen2} onConfirm={onConfirmClosePO} onClose={handleConfirmClose2} action="Close SCO" />
      <ConfirmationPopover onOpen={confirmOpen3} onConfirm={onConfirmDeletePO} onClose={handleConfirmClose3} action="Delete SCO" />
      <ConfirmationPopover onOpen={editConfirmOpen} onConfirm={onConfirmEditPO} onClose={handleEditConfirmClose} action="Edit SCO" />
    </>
  );
}
export default ScoList;
